module.exports = __webpack_public_path__ + "static/media/P23.d0a42b2b.png";